.option-label {
  white-space: nowrap;
}
